
import { FormType, IDataGridPageRequest } from 'shared';


export namespace InfoDatosBdContainerActions {

    export class ListarBaseDatos {
        static readonly type = '[INFO-DATOS-BD-CONTAINER] ListarBaseDatos';
        constructor(public payload?: any) { }
    }

    export class SetSearchForm {
        static readonly type = '[INFO-DATOS-BD-CONTAINER] SetSearchForm';
        constructor(public payload: any) { }
    }

    export class AgregarArchivoDescarga {
        static readonly type = '[INFO-DATOS-BD-CONTAINER] AgregarArchivoDescarga';
        constructor(public payload: { item: any }) { }
    }
    export class EliminarArchivoDescarga {
        static readonly type = '[INFO-DATOS-BD-CONTAINER] EliminarArchivoDescarga';
        constructor(public payload: { item: any }) { }
    }
    export class DescargarZip {
        static readonly type = '[INFO-DATOS-BD-CONTAINER] DescargarZip';
        constructor() { }
    }

    export class getObtenerFechaCorte {
        static readonly type = '[BUSCADOR-PROGRAMA-PROG-CONTAINER] ObtenerFechaCorte';
        constructor(public payload: { modulo: string}) { }
    }
      export class getObtenerInstFechaCorte {
        static readonly type = '[BUSCADOR-PROGRAMA-PROG-CONTAINER] getObtenerInstFechaCorte';
        constructor(public payload: { modulo: string}) { }
    }
}
